import { render, staticRenderFns } from "./adjustment-allocate.vue?vue&type=template&id=5d9da895&scoped=true"
import script from "./adjustment-allocate.vue?vue&type=script&lang=ts"
export * from "./adjustment-allocate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9da895",
  null
  
)

export default component.exports